import * as actionType from './types';
import axios from '../../../common/config/axios';
import { isDesktop } from 'react-device-detect';

export const getVendorList = (props) => (dispatch, getState) =>
{
  props.country_id = getState().currentUser.data.country_id;
  props.language_code = getState().currentUser.data.language_code;
  props.country_code = getState().currentUser.data.country_code;
    // console.log(props);
    axios.get(`${(isDesktop) ? 'games' : 'home'}/vendor_list`, {params: props})
    .then(function (response)
    {
      dispatch (
      {
        type: actionType.VENDOR_LIST,
        value: response.data
      })
    })
    .catch(err =>
    {

    });
};

export const getGameList = (props) => dispatch =>
{
    // console.log(props);
    axios.get('games/game_list', {params: props})
    .then(function (response)
    {
      dispatch (
      {
        type: actionType.GAME_LIST,
        value: response.data
      })
    })
    .catch(err =>
    {

    });
};

export const accessGame = (props, vendor) => dispatch =>
{
  // console.log(props);
    let gameUrl = '';
    if(props.other_url)
    {
      gameUrl = (props.game_mode === 1) ? `${vendor}/get_lottery_url` : `${vendor}/get_demo_lottery_url`;
    }
    else
    {
      gameUrl = (props.game_mode === 1) ? `${vendor}/get_game_url` : `${vendor}/get_demo_url`;
    }
    axios.post(gameUrl, props)
    .then(function (response)
    {
      dispatch (
      {
        type: actionType.GAMES_GAME_ACCESS,
        value: response.data
      })
    })
    .catch(err =>
    {

    });
};